import { IconProps } from '@chakra-ui/react';

export const IconDefaultProps: IconProps = {
    fill: 'none',
    viewBox: '0 0 24 24',
};
